import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const loadFormAttributes = createAction("".concat(stateName, "/loadFormAttributes"));
export const saveSettings = createAction("".concat(stateName, "/saveSettings"));
export const selectCountry = createAction("".concat(stateName, "/selectCountry"));
export const selectCity = createAction("".concat(stateName, "/selectCity"));